<template>
    <!-- 倒计时组件 -->
    <span class="countdown" v-text="time"></span>
</template>

<script>
export default {
    data () {
        return {
            time: ''
        };
    },
    props: {
        endTime: {
            type: String
        },
        // 时长(秒)
        duration: {
            type: Number,
            validator: function (value) {
                return value > 0;
            }
        }
    },
    watch: {
        endTime: function () {
            this.init()
        },
        duration: function () {
            this.init()
        }
    },
    methods: {
        init () {
            let eTime = new Date();
            if (this.endTime) {
                eTime = new Date(this.endTime);
            }
            if (this.duration) {
                eTime = new Date((eTime.setSeconds(eTime.getSeconds() + this.duration)));
            }
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.timeDown(eTime);
            }, 1000);
        },
        timeDown (endTime) {
            let nowTime = new Date();
            let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
            let h = this.formate(parseInt((leftTime / (60 * 60)) % 24));
            let m = this.formate(parseInt((leftTime / 60) % 60));
            let s = this.formate(parseInt(leftTime % 60));
            if (leftTime === 300) {
                this.$emit('time-end-warning', 300);
            }
            if (leftTime < 1) {
                this.$emit('time-end');
                clearInterval(this.timer);
                h = '00'
                m = '00'
                s = '00'
            }
            this.time = `${h}:${m}:${s}`; // 需要修改时间样式的话 ，比如需要什么30分钟倒计时，就只保留分和秒
        },
        formate(time) {
            if (time >= 10) {
                return time;
            } else {
                return `0${time}`;
            }
        }
    },
    mounted () {
        this.init()
    }
};
</script>

<style lang="less" scoped>
    .countdown {
        font-size: 24px;
    }
</style>
